module.exports = __webpack_public_path__ + "static/media/rp_resized.6fc9605a.png";